import { resolveLegacyGuideProductRedirect } from './legacyGuideProductRedirects';
import translations from './documentTranslations.json';
import { publicPageHref } from './sitePagePolicy';
import { buildLanguageUrl, getLanguageOrigin, isProductionHost, parseLanguagePath } from './localeRouting';
const normalizeLanguage = lang => String(lang).toLowerCase() === 'zh-tw' ? 'zh-TW' : lang === 'ind' ? 'id' : lang;
const bySlug = {};
Object.entries(translations).forEach(([id, locales]) => Object.values(locales).forEach(slug => { bySlug[slug] = id; }));
export function translatedDocumentPath(path, language) {
  let slug;
  try { slug = decodeURIComponent(path.replace(/^\/document\//, '').replace(/\/$/, '')); } catch (_) { return '/document'; }
  const id = bySlug[slug] || Object.keys(translations).find(key => slug.toUpperCase().endsWith('-' + key));
  const target = id && translations[id][normalizeLanguage(language)];
  return target ? '/document/' + target : '/document';
}
export function documentAliasRedirect(path, language) {
  if (!path.startsWith('/document/')) return null;
  const target = translatedDocumentPath(path, language);
  let decoded;
  try { decoded = decodeURIComponent(path); } catch (_) { return null; }
  return target !== '/document' && target !== decoded ? target : null;
}
const exampleNames = {vi:'nguyen-van-a',en:'alex-taylor',ja:'yamada-taro',ko:'kim-minjun',fr:'camille-martin',de:'max-mustermann',es:'alex-garcia',it:'mario-rossi',pt:'ana-silva',id:'budi-santoso',ms:'ahmad-hakim',th:'somchai',zh:'wang-ming','zh-TW':'chen-yating'};
export function localizeDocumentHtml(html, language) {
  const lang = normalizeLanguage(language);
  const origin = getLanguageOrigin(lang);
  let content = String(html || '').replace(/card\.ninex\.one\/nguyen-van-a/g, `example.com/card/${exampleNames[lang] || 'alex-taylor'}`);
  return content.replace(/\bhref=(['"])(.*?)\1/gi, (match, quote, href) => {
    let url;
    try { url = new URL(href.replace(/&amp;/g, '&'), origin); } catch (_) { return match; }
    if (!isProductionHost(url.hostname)) return match;
    // Link CMS có thể mang tiền tố ngôn ngữ cũ/khác hoặc subdomain cũ → quy về path gốc rồi dựng lại theo ngôn ngữ đích.
    let path = parseLanguagePath(url.pathname).pathname;
    if (path.startsWith('/blog/')) return match; // blog translation is managed by its own cluster
    if (path.startsWith('/document/')) path = translatedDocumentPath(path, lang);
    path = publicPageHref(resolveLegacyGuideProductRedirect(path) || path, lang);
    const target = (/^https?:\/\//i.test(path) ? path : buildLanguageUrl(lang, path)) + url.search + url.hash;
    return `href=${quote}${target.replace(/&/g, '&amp;')}${quote}`;
  });
}
